import React from 'react';
import PageHeader from '../../../components/PageHeader';
import { PrivacyDashboard } from '../../../components/privacy/PrivacyDashboard';
import { useDarkMode } from '../../../context/DarkModeContext';
import { useNavigate } from 'react-router-dom';
import { IoArrowBackOutline } from 'react-icons/io5';

export const Page: React.FC = () => {
  const { darkMode } = useDarkMode();
  const navigate = useNavigate();

  const handleBackToSettings = () => {
    navigate('/settings');
  };

  return (
    <div className="h-full flex flex-col">
      <div className="sticky top-0 z-40">
        <PageHeader
          title="Privacy Settings"
          subtitle="Manage your privacy preferences, consent settings, and data rights"
          primaryButton={
            <button
              onClick={handleBackToSettings}
              className={`inline-flex items-center px-4 py-2 rounded-md text-sm font-medium ${
                darkMode 
                  ? 'bg-gray-700 text-gray-200 hover:bg-gray-600' 
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              <IoArrowBackOutline className="w-4 h-4 mr-2" />
              Back to Settings
            </button>
          }
        />
      </div>
      
      <div className="flex-1 relative overflow-hidden">
        <div className="h-full overflow-y-auto pt-[72px]">
          <div className="p-4">
            <div className="container mx-auto max-w-4xl">
              <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} shadow-md rounded-lg p-6`}>
                <PrivacyDashboard />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}; 